export const columnsOngoingDelegation = [
  {
    dataIndex: 'validator',
    title: 'Validator',
    visible: true,
    sortable: false
  },
  {
    dataIndex: 'status',
    title: 'Pool Status',
    visible: true,
    sortable: true
  },
  {
    dataIndex: 'timeLeft',
    title: 'Time Left',
    visible: true,
    sortable: false
  },
  {
    dataIndex: 'spaceLeft',
    title: 'Space Left in Pool',
    visible: true,
    sortable: false
  },
  {
    dataIndex: 'estimated',
    title: 'Estimated Return',
    visible: true,
    sortable: false
  }
];

export const columnsCompletedDelegation = [
  {
    dataIndex: 'validator',
    title: 'Validator',
    visible: true,
    sortable: false
  },
  {
    dataIndex: 'estimated',
    title: 'Estimated Return',
    visible: true,
    sortable: false
  },
  {
    dataIndex: 'total',
    title: 'Total OPN Provided',
    visible: true,
    sortable: false
  },
  {
    dataIndex: 'rewards',
    title: 'OPN Rewards',
    visible: true,
    sortable: false
  }
];

export const columnsNested = [
  {
    dataIndex: 'name',
    title: 'Project'
  },
  {
    dataIndex: 'region',
    title: 'Country'
  },
  {
    dataIndex: 'type',
    title: 'Project Activity'
  },
  {
    dataIndex: 'value',
    title: 'Amount'
  }
];

export const columnsCertificates = [
  {
    dataIndex: 'media',
    title: '',
    visible: false,
    sortable: false
  },
  {
    dataIndex: 'title',
    title: 'Recipient',
    visible: true,
    sortable: true
  },
  {
    dataIndex: 'issued_at',
    title: 'Date',
    visible: true,
    sortable: true
  },
  {
    dataIndex: 'offset_amount',
    title: 'Amount',
    visible: true,
    sortable: true
  }
];

export const columnsRetireActivity = [
  {
    dataIndex: 'name',
    title: 'Project',
    visible: true,
    sortable: true
  },
  {
    dataIndex: 'region',
    title: 'Country',
    visible: true,
    sortable: true
  },
  {
    dataIndex: 'token_amount',
    title: 'Amount',
    visible: true,
    sortable: true
  },
  {
    dataIndex: 'starts_at',
    title: 'Retirement Date',
    visible: true,
    sortable: true
  }
];

export const columnsProjects = [
  {
    dataIndex: 'name',
    title: 'Name',
    sortable: true
  },
  {
    dataIndex: 'currentStage',
    title: 'Stage',
    sortable: true
  },
  {
    dataIndex: 'region',
    title: 'Location',
    sortable: true
  },
  {
    dataIndex: 'parsedSquare',
    title: 'Area, Ha',
    sortable: true
  },
  {
    dataIndex: 'deadline',
    title: 'Upload Deadline',
    sortable: true
  }
];

export const columnsCollateral = [
  {
    dataIndex: 'name',
    title: 'Project',
    sortable: false
  },
  {
    dataIndex: 'state',
    title: 'Pool Status',
    sortable: true
  },
  {
    dataIndex: 'statusState',
    title: 'Project Status',
    sortable: false
  },
  {
    dataIndex: 'stakedAmount',
    title: 'My Liquidity',
    sortable: false
  },
  {
    dataIndex: 'myOpnRewards',
    title: 'My OPN Reward',
    sortable: false
  }
];

export const columnsValidations = [
  {
    dataIndex: 'name',
    title: 'Project',
    sortable: false
  },
  {
    dataIndex: 'region',
    title: 'Location',
    sortable: false
  },
  {
    dataIndex: 'validationStatus',
    title: 'Validation Status',
    sortable: false
  },
  {
    dataIndex: 'validationRemaining',
    title: 'Time Remaining ',
    sortable: false
  },
  {
    dataIndex: 'validationStake',
    title: 'My Current Stake',
    sortable: false
  },
  {
    dataIndex: 'validationRewards',
    title: 'Total OPN Rewards ',
    sortable: false
  }
];

export const columnsRetire = [
  {
    dataIndex: 'project',
    title: 'Project',
    sortable: true
  },
  {
    dataIndex: 'balance',
    title: 'Balance',
    sortable: true
  }
];
